<template>
    <div class='text-stamp-info'>
        <InfoTitle title='水印设置'/>
        <Divider/>
        <InfoTitle title='水印文字'/>
        <LabelOption label='字体'/>
        <LabelInput label='字号'/>
        <div>xxxxx</div>
        <LabelSlider label='透明度'/>
        <PositionSelector/>
        <LabelInput label='延迟出现（秒）' :time="true"/>
        <LabelOption label='显示时长'/>
    </div>
</template>

<script>
  import InfoTitle from "../base/InfoTitle";
  import Divider from '../base/Divider';
  import LabelSlider from "../base/LabelSlider";
  import LabelInput from "../base/LabelInput";
  import LabelOption from "../base/LabelOption";
  import PositionSelector from "../base/StampPositionSelector";
  export default {
    name: "TextStampInfo",
    components:{InfoTitle, Divider, LabelSlider, LabelInput, LabelOption, PositionSelector}
  }
</script>

<style scoped>
    .text-stamp-info{
        width:239px;
        height:850px;
        background:rgba(248,248,248,1);
        padding: 10px 12px;
    }

</style>
